import Screen from "./screen";
import StoryDialog from "./story";
import LookDialog from "./look-dialog";
import EquipDialog from "./equip-dialog";
import HelpDialog from "./help-dialog";
import DeathScreen from "./death-screen";
import CompleteScreen from "./complete-screen";
import { Input, Context } from "./input";

const Views = {
  GameScreen: new Screen(),
  StoryDialog: new StoryDialog(),
  LookDialog: new LookDialog(),
  EquipDialog: new EquipDialog(),
  HelpDialog: new HelpDialog(),
  DeathScreen: new DeathScreen(),
  CompleteScreen: new CompleteScreen()
}

// TODO: separate interface from engine
class Interface {
  constructor(stage) {
    // TODO: combined game state, world and stage object?
    this.stage = stage;
    this.screenStack = [];
    this.pushScreen(Views.GameScreen);
  }

  get screen() {
    return this.screenStack[this.screenStack.length - 1];
  }

  pushScreen(nextScreen, context) {
    this.screenStack.push(nextScreen);
    nextScreen.activate(context);
  }

  popScreen(context) {
    let prevScreen = this.screenStack.pop();
    prevScreen.deactivate(context);
  }

  handleInput(ev) {
    const command = this.screen.handleInput(ev.key, this.stage);
    if (command.context == Context.Player) {
      this.stage.player.pushCommand(command);
    } else if (command.context == Context.Screen) {
      this.pushCommand(command);
    }
  }

  handleTransition(ev) {
    if (ev.detail.command == "ShowStory") {
      this.pushScreen(Views.StoryDialog, ev.detail);
    } else if (ev.detail.command == "HideStory") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "HideLook") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "CloseDialog") {
      this.popScreen(ev.detail);
    } else if (ev.detail.command == "DeathScreen") {
      this.pushScreen(Views.DeathScreen, ev.detail);
    } else if (ev.detail.command == "CompleteScreen") {
      this.pushScreen(Views.CompleteScreen, ev.detail);
    } else if (ev.detail.command == "RestartGame") {
      document.location.reload();
    }
  }

  handleGameEvent(ev) {
    this.stage.adventure.appendLog(ev.detail);
  }

  pushCommand(command) {
    if (command.action == "Examine") {
      this.pushScreen(Views.LookDialog, command.detail);
    } else if (command == Input.Equip) {
      this.pushScreen(Views.EquipDialog, command.detail);
    } else if (command == Input.Help) {
      this.pushScreen(Views.HelpDialog, command.detail);
    }
  }

  rescale() {
    this.screen.rescale();
  }

  render() {
    this.screen.render(this.stage);
  }
}

export default Interface;
